<template>
  <div>
    <b-form-row class="mb-4">
      <b-col cols="2">
        <label class="mr-2">
          Basic salary
          <!-- Lương cơ bản -->
        </label>
      </b-col>
      <b-col cols="3">
        <my-currency-input v-model="item_selected.luongcoban" />
      </b-col>
      <b-col cols="1"></b-col>
      <b-col cols="2">
        <label class="mr-2">
          Social Insurance Contribution
          <!-- Lương đóng bảo hiểm -->
        </label>
      </b-col>
      <b-col cols="3">
        <my-currency-input v-model="item_selected.luongdongbh" />
      </b-col>
    </b-form-row>
    <b-form-row class="mb-4">
      <b-col cols="2">
        <label class="mr-2">
          Probation salary
          <!-- Lương cơ bản -->
        </label>
      </b-col>
      <b-col cols="3">
        <my-currency-input v-model="item_selected.luongthuviec" />
      </b-col>
      <b-col cols="1"></b-col>
      <b-col cols="2">
    
      </b-col>
      <b-col cols="3">
      
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import MyCurrencyInput from "../App/MyCurrencyInput";

export default {
  name: "HopDongLaoDongLuong",
  props: ["hopdong"],
  components: {
    MyCurrencyInput,
  },
  data() {
    return {
      item_selected: {
        luongcoban: 0,
        luongdongbh: 0,
        luongthuviec: 0,
      },
    }
  },
  created() {
    if (this.hopdong != null) this.initData();
  },
  methods: {
    initData() {
      this.item_selected.luongcoban = this.hopdong.luongcoban;
      this.item_selected.luongdongbh = this.hopdong.luongdongbh;
      this.item_selected.luongthuviec = this.hopdong.luongthuviec;
    }
  },
}
</script>